import * as React from "react";
import { ModuleMapProps } from "./typings";
import { Maps } from "./Maps";
import { DynamicMaps } from "./views/DynamicMaps";
import { withStores } from "stores";

export const MapsViews = withStores(
  "analytics",
  "hotels",
  "staticMap",
  "context",
  "poi",
  "routeStore",
  "flexModuleModelStore"
)((props: ModuleMapProps) => {
  if (props.flexTemplateNode.options.flexComponentView === "dynamic") {
    return <DynamicMaps {...props} />;
  }

  return <Maps {...props} />;
});

export default MapsViews;
